/**
 * Read more about middleware here:
 * http://redux.js.org/docs/advanced/Middleware.html
 *
 * Redux Toolkit's configureStore handles middleware composition and DevTools automatically.
 */

import promo from './promo';
import entrySignal from './entrySignal';
import stockParty from './stockParty';
import braze from './braze';
import session from './session';
import fetchMiddleware from './fetch';
import dialog from './dialog';
import segmentMiddleware from './segment';

/**
 * Creates an array of middleware functions.
 * Used by Redux Toolkit's configureStore.
 */
export const createMiddlewareArray = ({ analytics }) => {
	return [
		promo(analytics),
		entrySignal,
		stockParty,
		session,
		dialog,
		braze,
		fetchMiddleware,
		segmentMiddleware(analytics),
	];
};
